import React from 'react';
import { ChemicalRobReport } from '../../../types/ViewModel/TankCleaning/ROB/ChemicalRobReport';
import { PortCall } from '../../../types/ViewModel/PortCall';
import { ChemicalCategory, ChemicalCategoryList, ChemicalRobWrapper, Heading3, RobItemRow } from './ReportRob.styles';
import ChemicalCategoryReportItems from './ChemicalCategoryReportItems';
import ChemicalRobHeader from './ChemicalRobHeader';
import { useTankCleaningStore } from '../../../context/TankCleaningContext';
import ChemicalCategoryReportItemsSummary from './ChemicalCategoryReportItemsSummary';

type Props = {
    chemicalRobFormData: ChemicalRobReport;
    selectedPortCallId: number | null;
    previousPortCallWithRob?: PortCall;
    imoNumber: number;
};

const ReportRobComponent: React.FC<Props> = (props) => {
    const { isSummaryActive } = useTankCleaningStore();

    return (
        <ChemicalRobWrapper>
            <ChemicalRobHeader></ChemicalRobHeader>
            {props.chemicalRobFormData && (
                <ChemicalCategoryList>
                    {props.chemicalRobFormData?.chemicalCategoryRobReportItems.map((chemicalCategoryRobReportItem, index) => {
                        return (
                            <ChemicalCategory key={`chemicalCategory${chemicalCategoryRobReportItem.category?.categoryId}_${index}`}>
                                <Heading3>
                                    <RobItemRow>
                                        <span>{chemicalCategoryRobReportItem.category?.name}</span>
                                        <span>{'Prev ROB'}</span>
                                        <span className="location">
                                            <span>{'Location 1'}</span>
                                        </span>
                                        <span className="location">
                                            <span>{'Location 2'}</span>
                                        </span>
                                        <span className="location">
                                            <span>{'Location 3'}</span>
                                        </span>
                                        <span>{'New ROB'}</span>
                                    </RobItemRow>
                                </Heading3>
                                {!isSummaryActive && (
                                    <ChemicalCategoryReportItems
                                        chemicalRobReportItems={chemicalCategoryRobReportItem.chemicalRobReportItems}
                                        previousPortCallWithRob={props.previousPortCallWithRob}
                                        selectedPortCallId={props.selectedPortCallId}
                                    ></ChemicalCategoryReportItems>
                                )}
                                {isSummaryActive && (
                                    <ChemicalCategoryReportItemsSummary
                                        chemicalRobReportItems={chemicalCategoryRobReportItem.chemicalRobReportItems}
                                        previousPortCallWithRob={props.previousPortCallWithRob}
                                        selectedPortCallId={props.selectedPortCallId}
                                    ></ChemicalCategoryReportItemsSummary>
                                )}
                            </ChemicalCategory>
                        );
                    })}
                </ChemicalCategoryList>
            )}
        </ChemicalRobWrapper>
    );
};

export default ReportRobComponent;
